<template>
    <div class="rf-view confirmation-view">
        <NavigationBar :title="$t('confirmation.title')" />
        <main>
            <h1>
                {{ $t('confirmation.title') }}
            </h1>
            <p>
                {{ $t('confirmation.description') }}
            </p>
        </main>

        <FloatingFooter>
            <button class="button primary full" @click="close">
                {{ $t('buttons.close') }}
            </button>
        </FloatingFooter>
    </div>
</template>


<script lang="ts">
import { FloatingFooter, NavigationBar } from "@restofrit/components"
import { NavigationMixin } from "@simonbackx/vue-app-navigation";
import { Component, Mixins } from "vue-property-decorator";

@Component({
    components: {
        FloatingFooter,
        NavigationBar,
    },
})
export default class ConfirmationView extends Mixins(NavigationMixin) {
    close() {
        this.dismiss({ force: true })
    }
}
</script>